import { ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces'

export interface WorkersReducer {
    watchExperimentDataProcess: string | null
    watchMeasurementExperimentDataProcess: string | null
}

const initialState: WorkersReducer = {
    watchExperimentDataProcess: null,
    watchMeasurementExperimentDataProcess: null,
}

const workersReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.WORKERS.DATA_PROCESSING:
            return {
                ...state,
                watchExperimentDataProcess: action.payload,
            }
        case ACTIONS.WORKERS.MEASUREMENT_DATA_PROCESSING:
            return {
                ...state,
                watchMeasurementExperimentDataProcess: action.payload,
            }
        default:
            return state
    }
}

export default workersReducer
